export default __webpack_public_path__ + "images/DV.95d35b4.png";